import { friendlyErrorMessage } from '@/core/lib/dbError'

import { classifyPagesOnGate } from '@/core/api/extraction'
import { ok, technical, type Result } from '@/core/lib/result'

export type SplitPlan = {
  avgsPageIndicesInOrder: number[]
  tbPageIndicesInOrder: number[]
  ignoredPageIndices: number[]
}

export async function classifyPages(path: string | Blob): Promise<Result<SplitPlan>> {
  try {
    const gate = await classifyPagesOnGate(path)
    return ok({
      avgsPageIndicesInOrder: gate.avgs_page_indices_in_order,
      tbPageIndicesInOrder: gate.tb_page_indices_in_order,
      ignoredPageIndices: gate.ignored_page_indices,
    })
  } catch (error) {
    return technical(friendlyErrorMessage(error, "Seitenklassifizierung fehlgeschlagen."))
  }
}
